import { useMemo } from 'react';

import useSettingsStore from '@/shared/store/settings';
import { cn, isSplit } from '@/shared/utils';

import PinDisplay from '@/components/livescoring/Live/pins';

const RenderThrow = ({ value, isTenFrame }) => {
  const strikeStyle = isTenFrame
    ? {
        position: 'relative',
        width: 'auto',
        // backgroundColor: 'transparent',
      }
    : {
        // backgroundColor: strikeBgColor,
      };

  if (value === 'X') {
    return (
      <span
        className="absolute left-0 w-[200%] h-full top-0 z-[1] flex justify-center items-center"
        style={strikeStyle}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
        >
          <path
            fill="none"
            stroke="#000"
            strokeWidth="2"
            d="M13.2.8.8 13.2M.8.8l12.4 12.4"
          />
        </svg>
      </span>
    );
  }
  // if (value === '/') {
  //   return (
  //     <svg width="11" height="14" xmlns="http://www.w3.org/2000/svg">
  //       <path
  //         d="M8.785.333h.77a1 1 0 0 1 1 1v11.334a1 1 0 0 1-1 1H.978a1 1 0 0 1-.823-1.568L7.96.766a1 1 0 0 1 .824-.433Z"
  //         fill={color || '#000'}
  //       />
  //     </svg>
  //   );
  // }
  return value || '';
};

const BASE_GAP = 3;

const ScoreCard = ({ player, theme, scaleFactor = 1 }) => {
  const { includeGameTotal, showPinLeaves } = useSettingsStore();
  const { throws, scores, playerName, game, scoreCompletedGames, maxScore } =
    player;

  // Theme Style Declarations
  const containerTheme = useMemo(
    () => ({
      fontFamily: `${theme.font_family}, sans-serif`,
      backgroundColor: theme.section_container_background,
    }),
    [theme.section_container_background, theme.font_family]
  );
  const playerNameTheme = useMemo(
    () => ({
      color: theme.player_name.font_color,
      fontFamily: `${theme.player_name.font_family}, sans-serif`,
      fontSize: theme.player_name.font_size,
      fontWeight: theme.player_name.font_bold ? 'bold' : 'normal',
      fontStyle: theme.player_name.font_style,
    }),
    [theme.player_name]
  );
  const gameNumberTheme = useMemo(
    () => ({
      fontSize: theme.game_label.font_size || '18px',
      fontFamily: `${
        theme.game_label.font_family || 'Futura PT Cond'
      }, sans-serif`,
      color: theme.game_label.font_color || '#FFF',
      fontWeight: theme.game_label.font_bold ? 'bold' : 'normal',
    }),
    [theme.game_label]
  );
  const frameScoreTheme = useMemo(
    () => ({
      color: theme.frame_score.font_color,
      fontSize: theme.frame_score.font_size,
      fontWeight: theme.frame_score.font_bold ? 'bold' : 'normal',
      // backgroundColor: theme.scores_container_background,
    }),
    [theme.frame_score]
  );
  const throwsTheme = useMemo(
    () => ({
      color: theme.throws_style.font_color,
      fontSize: theme.throws_style.font_size,
      fontWeight: theme.throws_style.font_bold ? 'bold' : 'normal',
      // '--background-odd': theme.scores_container_background,
      // '--background-even': theme.top_frame_background,
    }),
    [
      theme.throws_style,
      // theme.scores_container_background,
      // theme.top_frame_background,
    ]
  );
  const totalScoreTheme = useMemo(
    () => ({
      color: theme.total_score.color || theme.total_score.font_color,
      fontFamily: `${theme.total_score.font_family}, sans-serif`,
      fontSize: theme.total_score.font_size,
      fontWeight:
        theme.total_score.font_weight || theme.total_score.font_bold
          ? 'bold'
          : 'normal',
    }),
    [theme.total_score]
  );
  /*const totalLabelTheme = useMemo(
    () => ({
      color: theme.total_label.color || theme.total_label.font_color,
      fontFamily: `${theme.total_label.font_family}, sans-serif`,
      fontSize: theme.total_label.font_size,
      fontWeight:
        theme.total_label.font_weight || theme.total_label.font_bold
          ? 'bold'
          : 'normal',
    }),
    [theme.total_label, theme.total_score.font_family]
  );*/
  // End of Theme Style Declarations

  return (
    <section style={containerTheme}>
      <div className="flex justify-between px-2 py-1/2 items-baseline">
        <p className="uppercase" style={playerNameTheme}>
          {playerName}
        </p>
        <p style={gameNumberTheme}>Game {game}</p>
      </div>

      <div className="flex">
        {/*Frames container*/}
        <ul
          className="list-none m-0 p-0 flex flex-1"
          style={{
            backgroundColor: theme.top_frame_background,
            // gap: Math.min(4, Math.floor(BASE_GAP / scaleFactor)),
          }}
        >
          {Array.from({ length: 10 }).map((_, index) => (
            <li
              key={index}
              className={cn([
                'text-center flex relative flex-col',
                // 'after:content-[""] after:absolute after:size-[2px] after:bg-black after:top-0 after:left-0 after:h-full',
              ])}
              style={{
                flex: index === 9 ? '1.5' : '1',
                // marginRight: Math.min(4, Math.floor(BASE_GAP / scaleFactor)),
                // borderRight: `${Math.min(4, Math.floor(BASE_GAP / scaleFactor))}px solid black`,
                // boxShadow: `black -${Math.min(4, Math.floor(BASE_GAP / scaleFactor))}px 0px 0px 0px`
              }}
            >
              {/* render pin leaves */}
              {showPinLeaves && (
                <div className="w-full min-h-8 flex justify-center items-center bg-gray-100">
                  {index <= Math.floor(player.throws.length / 2) && (
                    <PinDisplay
                      values={[
                        player.pins[index * 2],
                        player.pins[index * 2 + 1],
                      ]}
                    />
                  )}
                </div>
              )}

              {/* render two (three for 10th frame) cells for every index */}
              {(index !== 9 || throws.length >= 19) && (
                <div
                  className={cn(
                    'flex justify-center items-center min-h-[27px]'
                  )}
                  style={throwsTheme}
                >
                  <div
                    className={`relative flex-1 h-full flex justify-center items-center ${
                      isSplit(player.pins[index * 2])
                        ? cn(
                            'before:content-[""] before:absolute before:size-[20px]',
                            'before:rounded-full before:border-solid before:border-red-800 before:border',
                            'before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2'
                          )
                        : ''
                    }`}
                    // style={{
                    //   backgroundColor: 'var(--background-odd)',
                    // }}
                  >
                    <RenderThrow
                      pins={player.pins}
                      value={throws[index * 2]}
                      isTenFrame={index >= 9}
                      // strikeBgColor={theme.scores_container_background}
                      color={theme.throws_style.font_color}
                    />
                  </div>
                  <div
                    className="relative flex-1 h-full flex justify-center items-center"
                    // style={{
                    //   backgroundColor: 'var(--background-even)',
                    // }}
                  >
                    <RenderThrow
                      value={throws[index * 2 + 1]}
                      isTenFrame={index >= 9}
                      // strikeBgColor={theme.scores_container_background}
                      color={theme.throws_style.font_color}
                    />
                  </div>

                  {/* render a third throw for the 10th frame */}
                  {index === 9 && (
                    <div
                      className="relative flex-1 h-full flex justify-center items-center"
                      // style={{
                      //   backgroundColor: 'var(--background-even)',
                      // }}
                    >
                      <RenderThrow
                        value={throws[index * 2 + 2]}
                        isTenFrame={index >= 9}
                        // strikeBgColor={theme.scores_container_background}
                        color={theme.throws_style.font_color}
                      />
                    </div>
                  )}
                </div>
              )}

              {!(index !== 9 || throws.length >= 19) && (
                <div
                  className={cn(
                    'flex justify-center items-center h-full w-full'
                  )}
                  style={{
                    ...frameScoreTheme,
                    color: 'gray',
                    lineHeight: '20px',
                  }}
                >
                  Max
                </div>
              )}

              {/* render the score cell */}
              <div
                className="text-center h-full box-border min-h-[30px]"
                style={{
                  ...frameScoreTheme,
                  color:
                    index !== 9 || throws.length >= 19
                      ? frameScoreTheme.color
                      : 'gray',
                }}
              >
                {index === 9 && throws.length < 19 ? maxScore : scores[index]}
              </div>

              <div
                className="h-full z-10 absolute right-0"
                style={{
                  width: Math.min(4, Math.floor(BASE_GAP / scaleFactor)),
                  backgroundColor: containerTheme.backgroundColor,
                }}
              ></div>
            </li>
          ))}
        </ul>

        {/*Total block*/}
        <div
          className="text-center text-uppercase min-w-[76px] min-h-[42px] flex flex-col justify-around leading-none"
          style={{ backgroundColor: theme.total_score.background_color }}
        >
          <h3 className="m-0" style={totalScoreTheme}>
            {scoreCompletedGames +
              (includeGameTotal
                ? player.scores[player.scores.length - 1] || 0
                : 0)}
          </h3>
        </div>
      </div>
    </section>
  );
};

export default ScoreCard;
